"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var classnames_1 = __importDefault(require("classnames"));
var TextField_1 = __importDefault(require("../TextField"));
var Icon_1 = __importDefault(require("../Icon"));
var Checkbox_1 = __importDefault(require("../Checkbox"));
var Grid_1 = __importDefault(require("../Grid"));
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var typography = _a.typography, spacing = _a.spacing;
    return ({
        icon: {
            fontSize: typography.fontSize * 1.4
        },
        checkbox: {
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        textField: {
            paddingLeft: 0,
            '& > .MuiInput-formControl': {
                marginTop: 0
            }
        },
        textFieldContainer: {
            flexGrow: 3
        },
        container: {
            paddingLeft: spacing(),
            paddingRight: spacing()
        }
    });
});
var debounce = function (fn, delay) {
    var timeout;
    return function (e) {
        e.persist();
        clearTimeout(timeout);
        timeout = setTimeout(function () { return fn(e); }, delay);
    };
};
var MultiSelectHeader = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var handlerAllChange = props.handlerAllChange, label = props.label, search = props.search, handleSearch = props.handleSearch, showCheckbox = props.showCheckbox, classes = props.classes, placeholder = props.placeholder, statusSelectedItems = props.statusSelectedItems;
    var internalClasses = useStyles();
    var textFieldPlaceholder = (0, react_1.useMemo)(function () {
        if (typeof label === 'string')
            return label;
        if (placeholder)
            return placeholder;
        return '';
    }, [placeholder, label]);
    return (react_1.default.createElement(Grid_1.default, { container: true, alignItems: "center", wrap: "nowrap", classes: { container: internalClasses.container } },
        showCheckbox && (react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Checkbox_1.default, { color: statusSelectedItems.partSelected ? 'secondary' : 'primary', isChecked: !statusSelectedItems.notSelected, indeterminate: statusSelectedItems.partSelected, onChange: handlerAllChange, classes: { formControlLabel: { root: internalClasses.checkbox } } }))),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, classes: { item: internalClasses.textFieldContainer } },
            react_1.default.createElement(TextField_1.default, { autoFocus: true, placeholder: textFieldPlaceholder, defaultValue: search, onChange: debounce(handleSearch, 250), fullWidth: true, classes: __assign(__assign({}, (((_a = classes === null || classes === void 0 ? void 0 : classes.menuHeader) === null || _a === void 0 ? void 0 : _a.search) || {})), { root: (0, classnames_1.default)(internalClasses.textField, ((_c = (_b = classes === null || classes === void 0 ? void 0 : classes.menuHeader) === null || _b === void 0 ? void 0 : _b.search) === null || _c === void 0 ? void 0 : _c.root) || '') }), InputProps: {
                    startAdornment: (react_1.default.createElement(Icon_1.default, { kind: "search", classes: __assign(__assign({}, (((_d = classes === null || classes === void 0 ? void 0 : classes.menuHeader) === null || _d === void 0 ? void 0 : _d.searchIcon) || {})), { root: (0, classnames_1.default)(internalClasses.icon, ((_f = (_e = classes === null || classes === void 0 ? void 0 : classes.menuHeader) === null || _e === void 0 ? void 0 : _e.searchIcon) === null || _f === void 0 ? void 0 : _f.root) || '') }) }))
                } }))));
};
exports.default = MultiSelectHeader;
